import { HStack, IconButton } from '@chakra-ui/react'
import { LIMIT_PAGE_BREAK } from 'configs/constants'
import { DARK_TEXT_MUTED } from 'constants/dark-tokens'
import SvgIcon from 'components/SvgIcon'

export interface IPagination {
  includePagination?: boolean
  totalResults?: number
  pageIndex?: number
  limit?: number
  gotoPage?: (selectedPage: number) => void
}

interface IPaginationProps {
  pagination: IPagination
  // Opt-in dark-surface styling (default light).
  dark?: boolean
}

const ProcessPagination = (props: IPaginationProps) => {
  const { pagination, dark = false } = props
  const { pageIndex: page = 1, gotoPage = () => null, totalResults = 0, limit = LIMIT_PAGE_BREAK } = pagination
  const pageIndex = Number(page)
  const numberOfPages = Math.ceil(totalResults / limit)

  const iconColor = dark ? DARK_TEXT_MUTED : 'gray.600'
  const buttonSx = dark
    ? {
        background: 'transparent',
        _hover: { background: 'rgba(255,255,255,0.08)' },
        _active: { background: 'rgba(255,255,255,0.08)' },
        _disabled: { opacity: 0.35, cursor: 'not-allowed' }
      }
    : { background: '#fff' }

  return (
    <HStack spacing={2}>
      <IconButton
        border="none"
        width="24px"
        height="24px"
        aria-label="Previous drills"
        sx={buttonSx}
        icon={<SvgIcon iconName="prev-icon" color={iconColor} />}
        onClick={() => gotoPage(pageIndex - 1)}
        disabled={pageIndex === 1}
      />
      <IconButton
        border="none"
        width="24px"
        height="24px"
        aria-label="Next drills"
        sx={buttonSx}
        icon={<SvgIcon iconName="next-icon" color={iconColor} />}
        onClick={() => gotoPage(pageIndex + 1)}
        disabled={pageIndex === numberOfPages}
      />
    </HStack>
  )
}

export default ProcessPagination
